import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LogoutService } from '../components/login/logout.service';

@Injectable({
	providedIn: 'root',
	deps: [Router, LogoutService, MatSnackBar],
})
export class HttpAuthInterceptor implements HttpInterceptor {

	constructor(
		private m_router: Router,
		private m_logoutService: LogoutService,
		private snackBar: MatSnackBar,
	) { }

	public intercept(p_req: HttpRequest<any>, p_next: HttpHandler): Observable<HttpEvent<any>> {
		return p_next.handle(p_req).pipe(catchError((error, caught) => {
			this.handleError(error);
			return of(error);
		}));
	}

	public handleError(p_err: HttpErrorResponse): Observable<any> {
		if (p_err.status === 401) {
			this.m_logoutService.logout().subscribe({
				next: (res) => {
					this.m_router.navigate(['anmelden']);
				},
			});
		} else if (p_err.status !== 404) {
			let errorMsg: string = p_err.statusText;
			if (p_err && p_err.error && p_err.error.message) {
				errorMsg = p_err.error.message;
			} else if (p_err.message) {
				errorMsg = p_err.message;
			}
			if (this.snackBar) {
				this.snackBar.open(errorMsg, null, {
					duration: 5000,
				});
			}
		}
		throw p_err;
	}

}
